<template>
  <bread-crumb :class="{ 'breadcrumb-hidden-mobile': !isSidebarOpen }">
    <BreadCrumbItem
      v-for="(route, index) in $route.matched.slice()"
      :key="route.name"
      style="display:inline-block"
    >
      <span
        v-if="index < $route.matched.length - 1"
        class="breadcrumb-link">
        {{ route.name }}
      </span>
      <span v-else class="breadcrumb-current">{{ route.name }}</span>
    </BreadCrumbItem>
  </bread-crumb>
</template>

<script>
import BreadCrumb from './Breadcrumb';
import BreadCrumbItem from './BreadcrumbItem';

export default {
  name: 'route-breadcrumb',
  components: {
    BreadCrumb,
    BreadCrumbItem
  },
  computed: {
    isSidebarOpen() {
      return !this.$sidebar.isMinimized;
    }
  }
};
</script>

<style scoped>
.breadcrumb-link {
  color: var(--primary-color);
  padding-left: 0px;
}

@media screen and (max-width: 768px) {
  .breadcrumb-hidden-mobile {
    display: none !important;
  }
}

</style>